module.exports = __webpack_public_path__ + "img/gu.851bfab2.svg";